export enum AxisMode {
    number,
    date
}
